const section = document.querySelector('.home-picture-cloud');

if (section) {
    const images = section.querySelectorAll('.home-picture-cloud-img');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.15 },
    );

    images.forEach((el, i) => {
        el.style.setProperty('transition-delay', `${i * 120}ms`);
        observer.observe(el);
    });
}
